import { UnorderedListOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { useBlockType } from '../../hooks/useBlockType'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

import { BulletListButtonProps } from './interface'

export const BulletListButton = ({ iconSize }: BulletListButtonProps) => {
  const [blockType, setBlockType] = useBlockType()
  return (
    <MenuButton
      actived={blockType === 'bullet'}
      tooltip={
        <Flex vertical align='center'>
          <span>无序列表</span>
          <span>{SHORTCUTS.BULLET_LIST}</span>
        </Flex>
      }
      onClick={() => {
        setBlockType({ type: 'bullet' })
      }}
    >
      <UnorderedListOutlined style={{ fontSize: iconSize }} />
    </MenuButton>
  )
}
